module.exports = __webpack_public_path__ + "static/media/TaskFullRounded.0687491c.png";